import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms'; 
import { Router, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../_services';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';

  constructor(  private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) {
    // redirecting if already logged in
      if (this.authenticationService.currentUserValue) { 
        // console.log("Login Component -> user Already logged in",this.authenticationService.currentUserValue.subscriptionStatus)
        let toRoute:string = this.authenticationService.currentUserValue.subscriptionStatus ? "/subscription" : "/my-tickets";
        this.router.navigate([toRoute],{relativeTo: this.route});
      }
    }

  ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
  });

  // get return url from route parameters or default to '/'
  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }


    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      } 

      this.loading = true;
      this.authenticationService.login(this.f.username.value, this.f.password.value)
          .subscribe(
              data => {
              //this.router.navigate(["/my-tickets"]);
              // window.location.href = "#/my-tickets";
              // if(data.subscriptionStatus){
              //   window.location.href = "#/subscription";
              // }
              window.location.href = data.subscriptionStatus ? "#/subscription" : "#/my-tickets";
              window.location.reload();
              },
              error => {
                  this.error = error;
                  this.loading = false;
              });
  }


}
